/* vue2
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
*/

//vue3
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

// Vue 3 では createApp 関数を使ってアプリケーションインスタンスを作成します
const app = createApp(App)

// ルーター、ストア、Vuetify などのプラグインは .use() で登録します
app.use(router)
app.use(store)
app.use(vuetify)

// 最後に '#app' にマウント（描画）します
app.mount('#app')